export default __webpack_public_path__ + "images/99bf6df26f3565cbf2645e00eec35f03.svg";